<template>
    <div style="padding: 1em;">
        <h4 style="text-align: center;">INPUT FASILITAS KREDIT</h4>
        <table border="0" cellpadding="6" cellspacing="0" style="width:100%; border-collapse:collapse; font-family:Arial, sans-serif; font-size:14px;">
            
            <tr>
                <td>
                    <tr>
                        <th>NAMA NASABAH</th>
                        <th>:</th>
                        <td colspan="3">
                            <input v-model="form.nama" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>PILIH JENIS KREDIT</th>
                        <th>:</th>
                        <td>
                            <select v-model="form.jenis_kredit">
                            <option value="">-- Pilih Jenis Kredit --</option> 
                            <option :value="`${item.nama_produk}`" v-for="(item, index) in jenis_produk" :key="index">{{ item.nama_produk }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>PILIH MASA USIA PENSIUN</th>
                        <th>:</th>
                        <td>
                            <!-- <input type="number" v-model="form.usia_pensiun"> -->
                            <select v-model="form.usia_pensiun">
                                <option value="">-- Pilih Usia Pensiun --</option>
                                <option :value="`${item}`" v-for="(item, index) in form.select_usia_pensiun" :key="index">{{ item }} Tahun</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>TANGGAL LAHIR / USIA</th>
                        <th>:</th>
                        <td>
                            <input type="date" v-model="form.tanggal_lahir" @change="onTanggalLahir">
                        </td>
                        <td style="font-weight: bold;">{{ usia_sekarang }} TAHUN</td>
                    </tr>
                    <tr>
                        <th>JANGKA WAKTU MAKSIMAL</th>
                        <th>:</th>
                        <td style="font-weight: bold;">
                            {{ jangka_waktu_maksimal }}
                        </td>
                    </tr>
                    <tr>
                        <th></th>
                        <th></th>
                        <td>
                            {{ tanggal_sekarang }}
                        </td>
                        <td style="font-weight: bold; color: red;">
                            01 Juni 2040
                        </td>
                    </tr>
                    <tr>
                        <th>USIA PADA SAAT JATUH TEMPO</th>
                        <th>:</th>
                        <td>59 Tahun 10 Bulan 20 hari</td>
                    </tr>
                    <tr>
                        <th>GAJI AMPRA</th>
                        <th>:</th>
                        <td>
                            <input type="text" v-model="form.gaji_ampra" @input="formatNumber('gaji_ampra')">
                        </td>
                        <td>
                            <input type="date" v-model="form.tanggal_gaji_ampra">
                        </td>
                    </tr>
                    <tr>
                        <th></th>
                        <th>:</th>
                        <td>
                            {{ form.tanggal_acuan }}
                        </td>
                    </tr>
                    <tr>
                        <th>PLAFOND KREDIT</th>
                        <th>:</th>
                        <td>
                            <input type="text" v-model="form.plafond_kredit" @input="formatNumber('plafond_kredit')">
                        </td>
                    </tr>
                    <tr>
                        <th>JANGKA WAKTU (Bulan)</th>
                        <th>:</th>
                        <td>
                            <input type="number" v-model="form.jangka_waktu" @input="hasilJangkaWaktuBulan">
                        </td>
                        <td style="font-weight: bold;">
                            {{ hasil_jangka_waktu_bulan }} Bulan
                        </td>
                        <!-- <td>15</td>
                        <td>174 Bulan</td>
                        <td>08 Mei 2040</td> -->
                    </tr>
                </td>
                <td>
                    <tr>
                        <th>ASURANSI PENJAMIN</th>
                        <th>:</th>
                        <td>
                            <select v-model="form.asuransi_penjamin">
                                <option value="">-- Pilih Asuransi Penjamin --</option>
                                <option value="JAMKRIDA">JAMKRIDA</option>
                                <option value="EKA LLOYD">EKA LLOYD</option>
                                <option value="CAR">CAR</option>
                                <option value="IFG LIFE">IFG LIFE</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>SALDO AKHIR KREDIT LAMA</th>
                        <th>:</th>
                        <td>
                            <input type="text" v-model="form.saldo_akhir_kredit_lama" @input="formatNumber('saldo_akhir_kredit_lama')">
                        </td>
                    </tr>
                    <tr>
                        <th>PINALTY PELUNASAN KREDIT</th>
                        <th>:</th>
                        <td></td>
                        <td></td>
                        <td>0.00</td>
                    </tr>
                    <tr>
                        <th>TOTAL PELUNASAN</th>
                        <th>:</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>SALDO AKHIR KREDIT LAMA</th>
                        <th>:</th>
                        <td>
                            <input type="text" v-model="form.saldo_akhir_kredit_lama" @input="formatNumber('saldo_akhir_kredit_lama')">
                        </td>
                    </tr>
                    <tr>
                        <th>PINALTY PELUNASAN KREDIT</th>
                        <th>:</th>
                        <td></td>
                        <td></td>
                        <td>0.00</td>
                    </tr>
                    <tr>
                        <th>TOTAL PELUNASAN</th>
                        <th>:</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>KEWAJIBAN BUNGA KREDIT LAMA</th>
                        <th>:</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>RASIO (ANGSURAN/GAJI) & TENOR</th>
                        <th>:</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th style="text-align: right; color: gray;">180</th>
                        <th></th>
                        <td>79.64%</td>
                    </tr>
                    <tr>
                        <th>PILIH DATA PETUGAS</th>
                        <th>:</th>
                        <td>
                            <input type="text" v-model="form.data_petugas">
                        </td>
                    </tr>
                    <tr>
                        <th>KATEGORI</th>
                        <th>:</th>
                        <td>
                            <select v-model="form.kategori">
                                <option value="">-- Pilih Kategori --</option>
                                <option value="BARU">BARU</option>
                                <option value="TAKE OVER">TAKE OVER</option>
                                <option value="TOP UP">TOP UP</option>
                            </select>
                        </td>
                    </tr>
                </td>
            </tr>
            
        </table>

        <hr>

        <br>
        <br>
        <br>
        <br>


        <table border="1" cellpadding="6" cellspacing="0" style="width:100%; border-collapse:collapse; font-family:Arial, sans-serif; font-size:14px;">
        <tr>
            <th colspan="6" style="text-align:center;">
                Informasi Lebih Lanjut Hubungi : ISHAK
            </th>
        </tr>

        <tr>
            <td>Terima Dari</td>
            <td colspan="2"><strong>PT. BANK SULSELBAR CABANG MAROS</strong></td>
            <td>Gaji Angguran</td>
            <td colspan="2">Rp 4,190,800</td>
        </tr>

        <tr>
            <td>Angsuran Per-Bulan</td>
            <td colspan="2" style="background:#00ff00;">Rp 3,337,626</td>
            <td>Masa Tunggu Tempo</td>
            <td colspan="2">07 Juni 2040</td>
        </tr>

        <tr>
            <td>Sisa Gaji Aktif</td>
            <td colspan="2" style="background:yellow;">Rp 853,174</td>
            <td>Nama Nasabah</td>
            <td colspan="2">ISHAK</td>
        </tr>

        <tr>
            <td style="text-align: center;"><strong>TOP UP</strong></td>
            <td style="text-align: center;"><strong>SKIM KREDIT : KUL</strong></td>
        </tr>
        <tr>
            <!-- LOGO -->
            <td rowspan="10" style="text-align:center; vertical-align:middle;">
                <!-- <img src="/mnt/data/6f6c1044-af47-46fc-ae04-012368032dd2.png" 
                    alt="Logo Bank Sulselbar" 
                    style="width:120px;"> -->
            </td>
            <!-- <td colspan="2" style="text-align:center;"><strong>TOP UP</strong></td>
            <td colspan="3" style="text-align:center;"><strong>SKIM KREDIT : KUL</strong></td> -->
        </tr>

        <tr>
            <td colspan="2">Plafond Kredit</td>
            <td></td>
            <td colspan="3">Rp 306,000,000</td>
        </tr>

        <tr>
            <td colspan="2">Jangka Waktu</td>
            <td></td>
            <td colspan="3">14 Tahun 6 Bulan</td>
        </tr>

        <tr>
            <td colspan="2">Biaya Administrasi</td>
            <td colspan="3" style="background:yellow;">Rp 8,415,000</td>
        </tr>

        <tr>
            <td colspan="2">Provisi</td>
            <td colspan="3">Rp -</td>
        </tr>

        <tr>
            <td colspan="2">Premi Asuransi JAMKRIDA</td>
            <td colspan="3" style="background:yellow;">Rp 12,902,000</td>
        </tr>

        <tr>
            <td colspan="2">Pelunasan Kredit</td>
            <td colspan="3">Rp -</td>
        </tr>

        <tr>
            <td colspan="2">Simpanan Wajib 1X ANGSURAN</td>
            <td colspan="3" style="background:#00ff00;">Rp 3,337,626</td>
        </tr>

        <tr>
            <td colspan="2"><strong>Total Potongan</strong></td>
            <td colspan="3">Rp 24,654,626</td>
        </tr>

        <tr>
            <td colspan="2"><strong>Sisa Bersih yang Diterima</strong></td>
            <td colspan="3"><strong>281,345,374</strong></td>
        </tr>

        <tr>
            <td>Terbilang</td>
            <td colspan="5">
                <em>
                    Dua Ratus Delapan Puluh Satu Juta Tiga Ratus Empat Puluh Lima Ribu
                    Tiga Ratus Tujuh Puluh Empat Rupiah
                </em>
            </td>
        </tr>
    </table>


    </div>
</template>

<script>
export default {
    data() {
        return {
            jenis_produk: [],
            form: {
                nama: '',
                jenis_kredit: '',
                usia_pensiun: '',
                select_usia_pensiun: [5,58,60,70,75,7,2,4],
                tanggal_lahir: '',
                gaji_ampra: '',
                tanggal_gaji_ampra: '',
                tanggal_acuan: '01 Januari 2023',
                data_petugas: '',
                kategori: '',
                plafond_kredit: '',
                jangka_waktu: '',
                asuransi_penjamin: '',
                saldo_akhir_kredit_lama: '',
            },
            now: '',
            jangka_waktu_maksimal: '14 Tahun 6 Bulan 16 Hari',
            hasil_jangka_waktu_bulan: 0,
            tanggal_sekarang: '',
            usia_sekarang: 0,
        }
    },

    mounted() {
        // Tanggal sekarang 
        const date = new Date();
        let day = date.getDate()
        let month = date.getMonth()
        let year = date.getFullYear()

        const monthNames = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ];

        this.now = date
        let currentDate = `${day} ${monthNames[month]} ${year}`
        this.tanggal_sekarang = currentDate
        // 

        fetch(`${this.$apiURL}/v1/jenis_produk`, {
            method : 'POST',
            headers : {
            'Content-Type' : 'application/json',
            },
        })
        .then(response => response.json())
        .then((result) => {
            this.jenis_produk = result         
        })

        

        // D6 left()
        
        //
    },

    methods: {
        onTanggalLahir() {
            let tanggal_lahir = new Date(this.form.tanggal_lahir);
            let sekarang = new Date();

            let umur = sekarang.getFullYear() - tanggal_lahir.getFullYear();
            let bulan = sekarang.getMonth() - tanggal_lahir.getMonth();

            // Jika bulan sekarang masih lebih kecil, atau bulan sama tapi tanggal belum lewat → umur - 1
            if (bulan < 0 || (bulan === 0 && sekarang.getDate() < tanggal_lahir.getDate())) {
                umur--;
            }
            // console.log("Usia sekarang:", umur);
            this.usia_sekarang = umur

            // ============

            
        },

        hasilJangkaWaktuBulan(){
            let result = (this.form.jangka_waktu * 12) - 6
            if(this.form.jangka_waktu == ''){
                this.hasil_jangka_waktu_bulan = 0
            } else {
                this.hasil_jangka_waktu_bulan = result
            }
        },

        formatNumber(field) {
            let value = this.form[field];
            if (!value) {
                this.form[field] = '';
                return;
            }
            // Hapus semua selain angka
            value = value.toString().replace(/[^0-9]/g, '');
            // Format ribuan (1.000.000)
            this.form[field] = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },

        // Jika ingin nilai asli tanpa titik (untuk backend)
        getRawNumber(field) {
            return this.form[field].replace(/\./g, '');
        },
        
    },
}
</script>

<style>
th {
    text-align: left;
}
</style>